<template>

    <SkeletonControl v-if="fetching" class="mt-5" />


    <div v-else class="bg-white rounded-xl p-4 lg:p-7 w-full">
        <div class="flex flex-row items-start justify-between">
            <p class="px-3 py-1 text-gray-600 font-medium text-lg lg:text-2xl border-l-8 border-theme-secondary mb-4 lg:mb-0"
                style="line-height: 1;">
                44TH ANNUAL GENERAL ASSEMBLY <br /> <span class="text-xs lg:text-sm">Headquarters Philippine Army,
                    Taguig
                    City</span></p>
            <div @click="this.$router.push('/events')"
                class="cursor-pointer w-5 h-5 lg:w-8 lg:h-8 flex items-center justify-center rounded-full p-1 bg-primary">
                <img src="@/assets/images/papsi_info_icon.svg" alt="">
            </div>
        </div>
        <div class="bg-white rounded-xl p-4 lg:p-7">
            <div class="w-full flex flex-col" v-show="!regEnded">
                <div
                    class="text-theme-primary text-lg leading-4 uppercase font-bold text-center italic items-center justify-center flex w-full mb-2 lg:mb-5">
                    <p>{{ label }}</p>
                </div>
                <div class="w-full flex justify-center gap-2 flex-wrap md:flex-nowrap">
                    <Tick :value="days.toString()" label="Days" margin />
                    <Tick :value="hour.toString()" label="Hrs" margin />
                    <Tick :value="minute.toString()" label="Mins" margin />
                    <Tick :value="seconds.toString()" label="Secs" />
                </div>

                <div class="text-white text-center flex justify-center">
                    <div class="w-full lg:max-w-[34rem] pt-5">
                        <Button v-if="button_visible" class="text-lg md:text-xl lg:text-2xl uppercase"
                            :button_text="button_text" :disabled="buttonDisabled" @clicked="handleButton()" rounded />

                    </div>
                </div>
            </div>
        </div>
    </div>

    <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
        :success="this.success" :note="this.warning" :question="this.question" z_value="z-50"
        @positiveClick="handlePositiveClick()" @negativeClick="show_message_modal = false" :positiveButton="positiveBtn"
        :negativeButton="negativeBtn" :default_width="'max-w-xl'" id='vote_modal'>
        <div class="w-full px-5 pt-2 pb-4 flex flex-col justify-center text-center items-center">
            {{ this.modal_message }}
        </div>
    </ModalControl>


    <ModalControl v-show="election_otp" v-bind:display="election_otp" z_value="z-50" :default_width="'max-w-xl'"
        id='vote_modal' closable @closed="election_otp = false">
        <div class="w-full px-5 pt-10 pb-4 flex flex-col justify-start text-left items-start">
            <p class="text-primary text-xl lg:text-2xl font-bold text-left">Election OTP</p>
            <p class="mb-3 lg:mb-6 text-sm lg:text-xl">Enter the One-Time Password (OTP) sent to your mobile number or
                email address </p>
            <div class="w-full items-center justify-center flex">
                <v-otp-input :is-disabled="false" ref="confirm_new_pin_input" input-classes="otp-input-register"
                    inputmode="numeric" :num-inputs="6" @on-complete="submitOTP" v-model:value="otp"
                    :should-auto-focus="true" :key="otpInputKey" />
            </div>

        </div>
    </ModalControl>

</template>
<script>
import { defineComponent } from 'vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import SkeletonControl from '@/components/controls/SkeletonControl.vue';
import Button from "@/components/controls/ButtonControl.vue";
import User from "@/services/User";
import Tick from "@/components/controls/TickControl.vue";
import VOtpInput from "vue3-otp-input";
import Election from '@/services/Election';
import mixin from '@/mixin';

export default defineComponent({
    components: {
        ModalControl,
        Button,
        SkeletonControl,
        VOtpInput,
        Tick
    },
    mixins: [mixin],
    inject: ['setLoading'],
    mounted() {
        let that = this;
        const state = that.$store.state;

        if (!state.credentials.username) {
            that.getUserInfo();
        } else {
            that.checkUserFlow();
        }
    },
    data() {
        return {
            items: [],
            negativeBtn: null,
            fetching: false,
            will_register: false,
            registrants: [],
            view_registrants: false,
            show_message_modal: false,
            election_otp: false,
            modal_message: '',
            otp: '',
            otpInputKey: 0,
            success: false,
            warning: false,
            voting_ended: false,
            error: false,
            question: false,
            expired: false,
            days: 0,
            hour: 0,
            minute: 0,
            seconds: 0,
            label: "Registration Starts In",
            button_text: "Register Now",
            button_visible: false,
            regEnded: false,
            buttonDisabled: true,
            intervalId: null,
            targetDate: null,
            currentPhase: null,
            hasReg: false,
            canReg: false,
            hasVoted: false,
            positiveBtn: 'Okay',
        }
    },
    computed: {
        sched() {
            return this.$store.state.sched;
        },
        isDevelopmentMode() {
            return process.env.VUE_APP_DEVELOPMENT_MODE === 'true';
        },
    },
    watch: {
        sched: {
            handler(newVal) {
                if (newVal?.event_date) {
                    this.startCountdown(newVal.event_date);
                }
            },
            immediate: true,
        },
    },
    beforeUnmount() {
        if (this.intervalId) clearInterval(this.intervalId);
    },
    methods: {
        submitOTP() {
            this.setLoading(true);

            Election.electionOTP(this.$cookies.get('user_session').hash, this.otp)
                .then((response) => {
                    this.$store.state.election_otp = response.data.data;
                    console.log("Fetch", this.$store.state.election_otp);
                    this.startElection();

                }).catch((error) => {
                    console.error("GA fetch failed:", error?.response?.data || error);
                    this.setLoading(false);
                    this.election_otp = false;
                    this.error = true;
                    this.otpInputKey++;
                    this.otp = '';
                    this.show_message_modal = true;
                    this.modal_message = error.response.data.message;
                    if (error.response.status == 403) {
                        this.expired = true
                        this.modal_message = "Your session has expired. Please log in again.";
                        this.$store.state.logged = false;
                    }
                });
        },
        startElection() {
            this.setLoading(true);
            Election.startVote(this.$cookies.get('user_session').hash, this.$store.state.election_otp.uuid, this.$store.state.election_otp.secret_key)
                .then((response) => {
                    this.setLoading(false);
                    this.$store.state.start_vote = response.data.data;
                    this.$router.push('/election');
                }).catch((error) => {
                    this.setLoading(false);
                    this.election_otp = false;
                    this.error = true;
                    this.show_message_modal = true;
                    this.modal_message = error.response.data.message;
                    if (error.response.status == 403) {
                        this.expired = true
                        this.modal_message = "Your session has expired. Please log in again.";
                        this.$store.state.logged = false;
                    }
                });
        },
        handleButton() {
            if (this.button_text === "Vote Now") {
                this.election_otp = true;
                return;
            }

            this.show_message_modal = true;
            this.modal_message = "Are you sure you want to register for the 44th General Assembly?";
            this.positiveBtn = 'Yes'
            this.will_register = true;
            this.negativeBtn = "Cancel";
            this.question = true;
            this.error = false;
            this.success = false;
            this.warning = false;
        },
        getGaInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.fetching = true;
            this.setLoading(true);

            Election.fetchElectionData()
                .then((response) => {
                    state.gaInfo = response.data.data;
                    this.initializeEventState();
                    this.fetching = false;
                    this.setLoading(false);
                })
                .catch((error) => {
                    console.error("GA fetch failed:", error?.response?.data || error);
                    this.setLoading(false);
                    this.fetching = false;
                    this.error = true;
                    this.show_message_modal = true;
                    this.modal_message = error.response.data.message;
                    if (error.response.status == 403) {
                        that.expired = true
                        that.modal_message = "Your session has expired. Please log in again.";
                        that.$store.state.logged = false;
                    }
                });
        },
        closed() {
            let that = this;
            that.$cookies.remove('user');
            that.$cookies.remove('user_session');
            that.$router.push('/');
            that.show_message_modal = false;
        },
        getUserInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.setLoading(true);

            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                state.credentials.first_name = data.info.first_name;
                state.credentials.last_name = data.info.last_name;
                state.credentials.middle_name = data.info.middle_name;
                state.credentials.regular = data.info.regular;
                state.credentials.express = data.express;
                state.credentials.pso_enroll = data.pso_enroll;
                state.credentials.pin_update = data.pin_update;
                state.credentials.membership_date = data.info.membership_date || null;
                state.credentials.status = data.status || null;
                state.credentials.account_no = data.info.account_number;
                state.gaUser = data.ga;
                state.credentials.email = data.info.email;
                state.credentials.gender = data.info.gender;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.credentials.mobile = data.info.mobile;
                state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
                state.credentials.suffix = data.info.suffix ?? '';
                state.credentials.qr = data.qr;
                state.credentials.uuid = data.uuid;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.hash = data.hash;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                state.credentials.tin = data.info.tin;
                const type2Config = data.config.find(item => item.type === 2);
                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                that.account_number = state.credentials.account_no;
                that.full_name = state.credentials.name;
                that.gender = state.credentials.gender;
                that.Astatus = state.credentials.status;
                that.Membership = state.credentials.membership_type;
                that.Member_since = state.credentials.membership_date;
                that.email = state.credentials.email;
                that.mobile = state.credentials.mobile;
                that.tin = state.credentials.tin;
                that.age = state.credentials.age;
                that.birthdate = state.credentials.birthdate;
                that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
                that.username = state.credentials.username;
                that.registered = state.credentials.registered_date;
                that.qr = data.qr;
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                const rawRegisteredDate = state.credentials.registered_date;
                if (rawRegisteredDate) {
                    const parts = rawRegisteredDate.split('-');
                    that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                const rawBirthdate = state.credentials.birthdate;
                if (rawBirthdate) {
                    const parts = rawBirthdate.split('-');
                    that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                that.checkUserFlow();
                that.setLoading(false);

            }).catch(function (error) {
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                if (error.response.status == 403) {
                    that.expired = true
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.$store.state.logged = false;
                }
            });
        },
        checkUserFlow() {
            const that = this;
            const state = that.$store.state;
            const noContact = !state.credentials.mobile || !state.credentials.email;
            const config = state.credentials.config;
            const temporaryPIN = state.credentials.pin_update;
            const isValidated = that.$cookies.get('validated');

            this.getGaInfo();

            if (state.credentials.deactivated) {
                this.$router.push('/user/settings');
                return;
            }

            if (noContact) {
                state.credentials.noContact = noContact;
                this.show_update = true;
                return;
            }

            if (state.credentials.enrolled_pin) {
                const hasValidConfig = config && config.status;
                const noContact = state.credentials.noContact;
                state.credentials.enrolled_pin = false;

                if (noContact) {
                    that.show_update = false;
                    that.show_pin_modal = false;
                    that.show_otp_modal = false;
                    that.$cookies.set('validated', true);
                } else {
                    if (hasValidConfig) {
                        that.requestOTP();
                    } else {
                        that.show_update = false;
                        that.show_pin_modal = false;
                        that.show_otp_modal = false;
                        that.$cookies.set('validated', true);
                    }
                }
                return;
            }


            if (!isValidated) {
                if (state.credentials.has_pin) {
                    this.show_pin_modal = true;
                } else {
                    this.$router.push('/user/settings');
                }
            }

            if (temporaryPIN) {
                this.$router.push('/user/settings');
                state.credentials.edit_temporary = true;
                return;
            }

            const missingInfo = !state.credentials.mobile || !state.credentials.email ||
                !state.credentials.tin || !state.credentials.birthdate;

            if (missingInfo && !that.$cookies.get('skipped')) {
                this.show_update = true;
            }
        },
        handlePositiveClick() {
            if (this.expired) {
                this.closed();
            } else if (this.will_register) {
                this.will_register = false;
                this.negativeBtn = null;
                this.show_message_modal = false;
                const payload = {
                    hash: this.$cookies.get('user_session').hash
                }
                const series = this.$store.state.gaInfo.code;
                this.setLoading(true);

                Election.GaRegister(payload)
                    .then((response) => {
                        this.$store.state.gaUser.has_registered = true;

                        this.evaluateGAFlow();

                        this.success = true;
                        this.warning = false;
                        this.error = false;
                        this.question = false;
                        this.setLoading(false);
                        this.show_message_modal = true;
                        this.modal_message = response.data.data.message;
                        this.positiveBtn = 'Okay';
                    })
                    .catch((error) => {
                        this.error = true;
                        this.warning = false;
                        this.success = false;
                        this.question = false;
                        this.setLoading(false);
                        this.show_message_modal = true;
                        this.positiveBtn = 'Okay';
                        this.modal_message = error.response.data.message || 'An error occurred';
                        if (error.response.status == 403) {
                            this.modal_message = "Your session has expired. Please log in again.";
                        }
                    });

            } else {
                this.show_message_modal = false;
                this.negativeBtn = null;
            }
        },
        toDate(val) {
            return new Date(val.replace(' ', 'T'));
        },
        initializeEventState() {
            this.evaluateGAFlow();
            this.startCountdown();
        },
        evaluateGAFlow() {
            const gaUser = this.$store.state.gaUser || {};
            const sched = this.$store.state.gaInfo.schedules;
            const now = new Date();

            const regStart = this.toDate(sched.registration_start);
            const regEnd = this.toDate(sched.registration_end);
            const voteStart = this.toDate(sched.voting_start);
            const voteEnd = this.toDate(sched.voting_end);
            
            // const regStart = this.toDate('2026-03-02 12:30:00');
            // const regEnd = this.toDate('2026-03-05 12:30:00');
            // const voteStart = this.toDate('2026-03-06 12:30:00');
            // const voteEnd = this.toDate('2026-03-10 12:30:00');

            const registration_started = now >= regStart;
            const registration_ended = now >= regEnd;
            const voting_started = now >= voteStart;
            const voting_ended = now >= voteEnd;

            const isMEV = gaUser.can_participate === true;

            // reset defaults
            this.button_visible = true;
            this.buttonDisabled = false;
            this.targetDate = null;
            this.label = "";

            // =========================================================
            // 🟢 MEV USERS
            // =========================================================
            if (isMEV) {
                // ❌ REGISTRATION NOT STARTED
                if (!registration_started) {
                    this.label = "Registration starts in";
                    this.button_text = "Not Yet Started";
                    this.buttonDisabled = true;
                    this.targetDate = regStart;
                    return;
                }

                // 🟠 REGISTRATION ENDED, VOTING NOT STARTED YET
                if (registration_ended && !voting_started) {
                    this.label = "Voting starts in";
                    this.targetDate = voteStart;

                    if (!gaUser.has_registered) {
                        this.button_visible = true;
                        this.buttonDisabled = true;
                        this.button_text = "Registration has ended";
                    } else {
                        this.button_visible = true;
                        this.buttonDisabled = true;
                        this.button_text = "Not yet started";
                    }
                    return;
                }

                // 🟡 REGISTRATION ONGOING (overlaps voting)
                if (registration_started && !registration_ended) {
                    if (!voting_started) {
                        this.label = "Voting starts in";
                        this.targetDate = voteStart;
                    } else {
                        this.label = "Voting ends in";
                        this.targetDate = voteEnd;
                    }

                    if (!gaUser.has_registered) {
                        this.label = "Registration ends in";
                        this.button_text = "Register Now";
                        this.buttonDisabled = false;
                    } else if (gaUser.has_registered && !voting_started) {
                        this.button_text = "Already Registered";
                        this.buttonDisabled = true;
                    } else if (gaUser.has_registered && voting_started) {
                        if (gaUser.has_participated) {
                            this.button_text = "Already Voted";
                            this.buttonDisabled = true;
                        } else {
                            this.button_text = "Vote Now";
                            this.buttonDisabled = false;
                        }
                    }
                    return;
                }

                // 🟣 VOTING ONGOING
                if (voting_started && !voting_ended) {
                    this.label = "Voting ends in";
                    this.targetDate = voteEnd;

                    if (!gaUser.has_registered) {
                        this.button_visible = true;
                        this.buttonDisabled = true;
                        this.button_text = "Registration has ended";
                    } else {
                        if (gaUser.has_participated) {
                            this.button_text = "Already Voted";
                            this.buttonDisabled = true;
                        } else {
                            this.button_text = "Vote Now";
                            this.buttonDisabled = false;
                        }
                    }
                    return;
                }

                // 🔴 VOTING ENDED
                if (voting_ended) {
                    if (!gaUser.has_registered) {
                        this.button_visible = false;
                        this.label = "Registration has ended";
                        this.targetDate = null;
                    } else {
                        this.label = "Voting has ended";
                        this.targetDate = null;
                        this.button_visible = false;
                    }
                    return;
                }
            }

            // =========================================================
            // 🔵 NON-MEV USERS
            // =========================================================
            else {
                if (!registration_started) {
                    this.label = "Registration starts in";
                    this.button_text = "Not yet started";
                    this.buttonDisabled = true;
                    this.targetDate = regStart;
                    return;
                }

                if (registration_ended && !voting_started) {
                    this.label = "Registration has ended";
                    this.targetDate = regEnd;

                    if (!gaUser.has_registered) {
                        this.button_visible = false;
                    } else {
                        this.button_text = "Already registered";
                        this.buttonDisabled = true;
                    }
                    return;
                }

                if (registration_started && !registration_ended) {
                    this.label = "Registration ends in";
                    this.targetDate = regEnd;

                    if (!gaUser.has_registered) {
                        this.button_text = "Register Now";
                        this.buttonDisabled = false;
                    } else {
                        this.button_text = "Already registered";
                        this.buttonDisabled = true;
                    }
                    return;
                }

                if (voting_started && !voting_ended) {
                    this.label = "Voting ends in";
                    this.targetDate = voteEnd;

                    if (gaUser.has_participated) {
                        this.button_text = "Already Voted";
                        this.buttonDisabled = true;
                        this.button_visible = true;
                    } else {
                        this.button_text = "Vote Now";
                        this.buttonDisabled = false;
                        this.button_visible = true;
                    }
                    return;
                }

                if (voting_ended) {
                    this.label = "Registration has ended";
                    this.button_visible = false;
                    this.targetDate = null;
                    return;
                }
            }
        },
        startCountdown() {
            if (this.intervalId) clearInterval(this.intervalId);

            this.intervalId = setInterval(() => {

                // If voting ended → stop timer
                if (!this.targetDate) return;

                const now = new Date();
                const diff = this.targetDate - now;

                if (diff <= 0) {
                    this.evaluateGAFlow(); // auto jump phase
                    return;
                }

                const d = Math.floor(diff / (1000 * 60 * 60 * 24));
                const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
                const m = Math.floor((diff / (1000 * 60)) % 60);
                const s = Math.floor((diff / 1000) % 60);

                this.days = d;
                this.hour = h;
                this.minute = m;
                this.seconds = s;

            }, 1000);
        },


    },
})
</script>
<style scoped>
.max-width-back {
    max-width: 50px;
}

.otp-input-register {
    width: 3.2rem;
    height: 4rem;
    padding: 4px;
    font-size: 2.5rem;
    margin: 0 0.3rem;
    border-radius: 0.75rem;
    border: 0.05rem solid #dfdfdf !important;
    background-color: #f3f4f6;
    text-align: center;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif !important;
}

.otp-input-register::-webkit-inner-spin-button,
.otp-input-register::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.otp-input-register:focus {
    outline: none;
    border: 0.2rem solid #016B00 !important;
}

/* Tablet (e.g., iPad) */
@media (max-width: 1024px) {
    .otp-input-register {
        width: 3.5rem !important;
        height: 4.5rem !important;
        font-size: 3rem !important;
        margin: 0 0.3rem;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .otp-input-register {
        width: 3rem !important;
        height: 4rem !important;
        font-size: 2.5rem !important;
        margin: 0 0.2rem !important;
    }
}

/* Extra small mobile (e.g., older phones) */
@media (max-width: 480px) {
    .otp-input-register {
        width: 2.5rem !important;
        height: 3rem !important;
        font-size: 1.5rem !important;
        margin: 0 0.2rem !important;
        border-radius: 0.6rem !important;
    }
}

input::placeholder {
    font-size: 15px;
    text-align: center;
    font-weight: 600;
}
</style>
